import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';

/**
 * Tracks whether a ProductCard is rendered inside a horizontally drag/scroll-able container
 * (the Embla `ProductCarousel`, or the native-scroll `Scroller` used by `MarketRecos`). Such
 * containers own the horizontal touch gesture, so the card must NOT also capture it for the
 * mobile multi-image swipe — otherwise the two gestures fight.
 *
 * Defaults to `false`: grid surfaces (the PLP organic grid, and the PLP inline recos /
 * sponsored-ad grid injected between organic results) never wrap with the provider, so swipe
 * stays enabled there.
 */
const CarouselContext = createContext(false);

/** Wraps a carousel/scroller subtree so descendant `ProductCard`s suppress their mobile image-swipe. */
export const CarouselProvider = ({ children }: { children: ReactNode }) => (
  <CarouselContext.Provider value={true}>{children}</CarouselContext.Provider>
);

/** Returns true when the consuming `ProductCard` sits inside a carousel/scroller. */
export const useIsInCarousel = (): boolean => useContext(CarouselContext);
